export enum PdfSidebarView {
  UNKNOWN = -1,
  NONE = 0,
  THUMBS = 1, // Default value.
  OUTLINE = 2,
  ATTACHMENTS = 3,
  LAYERS = 4,
}
